@if (selectedItem && isReadOnly && showInternalNavigator) {
    <app-internal-navigator
        [path]="routeToSingle"
        [label]="selectedItem.fullName"
        [isActive]="selectedItem.isActive"
    ></app-internal-navigator>
} @else {
    <app-type-ahead-contacts
        [isReadOnly]="isReadOnly"
        [setCompany]="true"
        [displaySelected]="displaySelectedContact"
        [searchAllCompanies]="true"
        [selectedContact]="selectedItem"
        (selectedContactChange)="onSelectedContact($event)"
        [path]="routeToSingle"
    >
    </app-type-ahead-contacts>
}
